import {useCallback} from 'react';
import {layerState} from '@src/store';
import {useRecoilState} from 'recoil';
import useNewLineText from '@src/hooks/useNewLineText';

function AlertLayer () {
  const [{data, callback}, setLayer] = useRecoilState(layerState);
  const {title, desc} = data;
  const trimDesc = useNewLineText(desc || '');

  const handleClickConfirmBtn = useCallback(() => {
    setLayer({open: false});
    callback && callback();
  }, [callback, setLayer]);

  return (
    // <!-- error 클레스 추가 -->
    <div className="inner_layer">
      <div className="layer_head">
        <strong className="tit_layer">{title}</strong>
      </div>
      <div className="layer_body">
        <p className="desc_layer">{trimDesc}</p>
      </div>
      <div className="layer_foot">
        <div className="bundle_btn">
          <button
            type="button"
            className="btn_ok"
            onClick={handleClickConfirmBtn}
            data-tiara-action-name={data.tiaraActionName}
            data-tiara-action-kind={data.tiaraActionType}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default AlertLayer;
